import * as React from "react";
const SvgArrowRight24Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 12,
        height: 20,
        fill: "black",
        viewBox: "0 0 12 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M1.707.293.293 1.707 8.586 10 .293 18.293l1.414 1.414L11.414 10 1.707.293Z",
      clipRule: "evenodd"
    })
  );
export default SvgArrowRight24Px;
